const secondsToStr = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  if (hours) return hours > 5 ? `+5 h` : `${hours} hrs`;
  const minutes = Math.round(seconds / 60);
  if (minutes) return `${minutes} min`;
  return `${seconds} seg`;
};

export default secondsToStr;
